import { IntlFormatters } from 'react-intl';
import * as yup from 'yup';
import { getOryPasswordValidationScheme } from '../../../../validations/oryPasswordValidationSchema';

export interface IActivateAccountFormData {
  password: string;
}

export enum FormFieldNames {
  Password = 'password',
}

export const defaultValues: IActivateAccountFormData = {
  password: '',
};

export function getActivateAccountValidationScheme(formatMessage: IntlFormatters['formatMessage']) {
  return yup.object().shape({
    [FormFieldNames.Password]: getOryPasswordValidationScheme(formatMessage),
  });
}
